import { createContext } from 'react';

/**
 * Shared by SDKChatView so a pending AskUserQuestion prompt can lift out of
 * the inline transcript into a single prominent overlay above the composer,
 * and so the host can dim the transcript / disable the composer while the
 * user answers.
 *
 * When no provider is present (e.g. a renderer story mounting the block view
 * directly) `enabled` is false and the prompt falls back to rendering inline.
 */
export interface AskUserOverlayContextValue {
  /**
   * When true, pending AskUserQuestion cards portal into `overlayEl` instead
   * of rendering inline in the transcript.
   */
  enabled: boolean;
  /** Portal target for the lifted card. Null until the overlay slot mounts. */
  overlayEl: HTMLElement | null;
  /**
   * Register/unregister an unanswered question by block id so the host can
   * track whether any prompt is awaiting a reply.
   */
  setPending: (blockId: string, pending: boolean) => void;
}

export const AskUserOverlayContext = createContext<AskUserOverlayContextValue>({
  enabled: false,
  overlayEl: null,
  setPending: () => {},
});
